import { IInfo } from '../../types';
import iconPng from './icon.png';
import iconSvg from './icon.svg';

export const info: IInfo = {
  name: 'Bored Game Company',
  url: 'https://in.boredgamecompany.com',
  emails: {
    contact: 'hello@boredgamecompany.com',
    sales: 'sales@boredgamecompany.com',
  },
  socials: [
    { name: 'Instagram', url: 'https://www.instagram.com/boredgamecompany/' },
    { name: 'Facebook', url: 'https://www.facebook.com/boredgamecompany/' },
    { name: 'YouTube', url: 'https://www.youtube.com/channel/UC3wiT2yh5k9rxV_3M9jAu9Q' },
    { name: 'Twitter', url: 'https://twitter.com/BoredGameComp' },
  ],
  phone: {
    india: '+91 87998 02963',
    uae: '+971541627353',
  },
  entity: {
    india: { legalEntity: 'Band of Capes Pvt. Ltd.' },
    uae: { legalEntity: 'Mantiq Corp Fz LLE' },
  },
  store: {
    address: 'Bored Game Company, Pune, India',
    gmaps: 'https://maps.app.goo.gl/qPdTE4o2BB36ijHeA',
    reviewUrl: 'https://g.page/r/CYYhMg-C-kvpEBM/review',
  },
  tagline: 'The best place to buy Board Games ',
  funTagline: 'Games and Fun',
  logo: {
    svg: iconSvg,
    png: iconPng,
  },
  parent: null,
};
